import { Box, CircularProgress, Grid, Typography } from "@mui/material"
import { useState, useEffect } from "react";
import TicketService from "../../services/tickets.service";
import CardViewTicket from "../card/CardViewTicket";
import SinResultados from "./SinResultados";
import SearchLoading from "./SearchLoading";

const TabTickets = ({textSearch,handleClose}) => {
    const [options, setOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const handleSearchTicket = async() => {
        if(textSearch?.length >= 2){
            setIsLoading(true);
            await TicketService.getAll({search: textSearch}).then((data)=>{
                setOptions(
                    data.map((item) =>{
                        return {
                            ...item,
                            tituloCard: `${item.id_tk} - ${item.titulo_tk}`,
                            descripCard: item.cuerpo_tk,
                            empresaCard: item?.createdEmp_tk,
                            keyCard: `${item?.id_tk}Ticket`
                        }
                    })
                )
            })
            .finally(() => {
                setIsLoading(false);
            });
        }
    };

    useEffect(() => {
        const delayWrite = setTimeout(() => {
            handleSearchTicket()
        }, 500)
        return () => clearTimeout(delayWrite)
    }, [textSearch])
    return (
        <Grid container>
            { !isLoading ? (
                <>
                    {options && options?.length > 0 ? (
                        options.map((tk)=>(
                            <Grid item xs={12} key={tk?.id_tk}>
                                <CardViewTicket
                                    key={tk?.id_tk}
                                    item={tk}
                                    onCloseModal={handleClose}
                                    textSearch={textSearch}
                                />
                            </Grid>
                        ))
                    ):(
                        <Grid item xs={12} key='sinTk'>
                            <SinResultados />
                        </Grid>
                    )}
                </>
            ):(
                <Grid item xs={12} key='circletabtk'>
                    <SearchLoading />
                </Grid>
            )}
        </Grid>
    )
}

export default TabTickets